import { motion } from "framer-motion";

export const fadeUp = {
    initial: { opacity: 0, y: 32 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.15 },
};

export default function Reveal({ children, delay = 0, className = "", ...rest }) {
    return (
        <motion.div
            initial={fadeUp.initial}
            whileInView={fadeUp.whileInView}
            viewport={fadeUp.viewport}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
            className={className}
            {...rest}
        >
            {children}
        </motion.div>
    );
}

export function SectionHeader({ eyebrow, title, subtitle }) {
    return (
        <div className="max-w-2xl">
            <Reveal>
                <div className="flex items-center gap-3 mb-4">
                    <span className="h-px w-10 bg-gold/70" />
                    <span className="text-gold text-xs font-mono uppercase tracking-[0.3em]">
                        {eyebrow}
                    </span>
                </div>
            </Reveal>
            <Reveal delay={0.08}>
                <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tight text-white">
                    {title}
                </h2>
            </Reveal>
            {subtitle ? (
                <Reveal delay={0.16}>
                    <p className="mt-5 text-cream/70 leading-relaxed text-base sm:text-lg">
                        {subtitle}
                    </p>
                </Reveal>
            ) : null}
        </div>
    );
}
